<template>
  <div class="home">
    <v-layout row>
      <v-flex xs12>
        <app-header />
      </v-flex>
    </v-layout>

    <section class="home__section">
      <v-container class="pa-0">
        <v-layout
          row
          class="home__section-row"
        >
          <p class="home__section-title subheading white--text">
            Lafd grod im Kino
          </p>
          <v-spacer />
          <v-btn
            :loading="loading"
            small
            flat
            class="home__show-all white--text caption"
            @click="showAll(0)"
          >
            Ois zoing
            <v-icon
              class="ml-1"
              right
              dark
            >
              arrow_right
            </v-icon>
          </v-btn>
        </v-layout>
        <v-divider />
      </v-container>
      <app-card :items="nowPlaying" />
    </section>

    <section class="home__section">
      <v-container class="pa-0">
        <v-layout
          row
          class="home__section-row"
        >
          <p class="home__section-title subheading white--text">
            Kimmd boid ins Kino
          </p>
          <v-spacer />
          <v-btn
            :loading="loading"
            small
            flat
            class="home__show-all white--text caption"
            @click="showAll(1)"
          >
            Ois zoing
            <v-icon
              class="ml-1"
              right
              dark
            >
              arrow_right
            </v-icon>
          </v-btn>
        </v-layout>
        <v-divider />
      </v-container>
      <app-card :items="upComming" />
    </section>

    <section class="home__section">
      <v-container class="pa-0">
        <v-layout
          row
          class="home__section-row"
        >
          <p class="home__section-title subheading white--text">
            Beliebt
          </p>
          <v-spacer />
          <v-btn
            :loading="loading"
            small
            flat
            class="home__show-all white--text caption"
            @click="showAll(2)"
          >
            Ois zoing
            <v-icon
              class="ml-1"
              right
              dark
            >
              arrow_right
            </v-icon>
          </v-btn>
        </v-layout>
        <v-divider />
      </v-container>
      <app-card :items="popular" />
    </section>

    <section class="home__section">
      <v-container class="pa-0">
        <v-layout
          row
          class="home__section-row"
        >
          <p class="home__section-title subheading white--text">
            Am besten bewertet
          </p>
          <v-spacer />
          <v-btn
            :loading="loading"
            small
            flat
            class="home__show-all white--text caption"
            to="/beste-bewertungen"
          >
            Ois zoing
            <v-icon
              class="ml-1"
              right
              dark
            >
              arrow_right
            </v-icon>
          </v-btn>
        </v-layout>
        <v-divider />
      </v-container>
      <app-card :items="topRated" />
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '../components/Header.vue';
import MovieCard from '../components/MovieCard.vue';

export default {
  components: {
    appHeader: Header,
    appCard: MovieCard,
  },
  computed: {
    ...mapState({
      nowPlaying: state => state.quickSearch.homePrev.nowPlaying,
      upComming: state => state.quickSearch.homePrev.upComming,
      popular: state => state.quickSearch.homePrev.popular,
      topRated: state => state.quickSearch.homePrev.topRated,
    }),
    loading() {
      return this.$store.getters.loading;
    },
  },
  created() {
    this.$store.dispatch('getResults', { category: 'now_playing', home: true });
    this.$store.dispatch('getResults', { category: 'upcoming', home: true });
    this.$store.dispatch('getResults', { category: 'popular', home: true });
    this.$store.dispatch('getResults', { category: 'top_rated', home: true });
  },
  methods: {
    showAll(item) {
      this.$router.push({ path: 'filme', query: { tab: item } });
    },
  },


};
</script>

<style lang="scss">
.home {
  &__section {
    margin: 20px 0 20px 0;


    .card__flex:nth-last-child(-n + 2) {
      display: none;

      @media (max-width: 1263px) {
        display: block;
      }
    }
  }

  &__section-title {
    margin-top: 8px;
    margin-left: 40px;

    @media (max-width: 1263px) {
      margin-left: 33px;
    }

    @media (max-width: 960px) {
      margin-left: 20px;
    }

    @media (max-width: 600px) {
      margin-left: 17px;
    }
  }

  &__section-row {
    border-bottom: 1px solid #546E7A;
  }

  &__show-all {
    margin-right: 40px;

    @media (max-width: 1263px) {
      margin-right: 30px;
    }

    @media (max-width: 960px) {
      margin-right: 20px;
    }

    @media (max-width: 600px) {
      margin-right: 15px;
    }
  }
}
</style>
